export default __webpack_public_path__ + "static/media/basketIcon.cfea7394.svg";